import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './PopupQuestion.scss';
import Popup from '../Popup';

const PopupQuestion = ({ visible, handleClosePopup, question }) => (
	<Popup visible={visible} handleClosePopup={handleClosePopup}>
		{question ? (
			<div className={s.popupInfo}>
				<div className={s.popupInfoTitle}>Заметили ошибку/хотите дополнить?</div>
				<div className={s.popupInfoText}>
					Если у Вас возникли вопросы по расчету рейтинга или характеристикам ЖК, то напишите нам на{' '}
					<a href="mailto:editor@living.ru">editor@living.ru</a>
				</div>
			</div>
		) : (
			<div className={s.popupInfo}>
				<div className={s.popupInfoTitle}>Что такое рейтинг Living?</div>
				<div className={s.popupInfoText}>
					Это комплексный числовой показатель комфорта проживания в жилом комплексе. Чем выше значение
					рейтинга, тем более комфортным будет проживание.
				</div>
				<div className={s.popupInfoTitle}>Как рассчитываются рейтинги?</div>
				<div className={s.popupInfoText}>
					Рейтинг расчитывается на основании более 60 параметров жилого комплекса, его расположения,
					окружающей среды, инфраструктуры, безопасности. Методика расчета разработана при содействии кафедры
					информационных технологий Санкт-Петербургского государственного университета.
				</div>
			</div>
		)}
	</Popup>
);

PopupQuestion.propTypes = {
	handleClosePopup: PropTypes.func,
	question: PropTypes.bool,
	visible: PropTypes.bool,
};

PopupQuestion.defaultProps = {
	handleClosePopup: () => {},
	question: false,
	visible: false,
};

export default withStyles(s)(PopupQuestion);
